import React, { useEffect, useRef, useState } from 'external/react';
import PropTypes from 'external/prop-types';

export function PdfViewer({ url, className = '', height = '100%', width = '100%' }) {
  const objectRef = useRef();
  const [ error, setError ] = useState(false);

  useEffect(() => {
    function setUp() {
      fetch(url)
        .then(res => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.blob();
        })
        .then(blob => {
          const pdfBlob = new Blob([ blob ], { type: 'application/pdf' });
          objectRef.current.data = URL.createObjectURL(pdfBlob);
        })
        .catch(e => {
          setError(true);
          console.error('ERROR', e);
        });
    }

    setUp();
  }, [ url ]);

  if (error) {
    return (
      <div>
        <span className="d-block">PDF konnte nicht geladen werden!</span>
        <a className="d-block" href={url} target="_blank" rel="noreferrer">{url}</a>
      </div>
    );
  }
  return (
    <object
      ref={objectRef}
      type="application/pdf"
      className={className}
      height={height}
      width={width}
      data=""
    />
  );
}

PdfViewer.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
};




// WEBPACK FOOTER //
// ./js/components/PdfViewer.jsx